module.exports = __webpack_public_path__ + "img/map2.545b9afb.png";